<template>
  <div>
    <div v-show="showPrivacyProgress || isAdmin">
      <div class="graphWrap">
        <h2>{{$t('message.labelBloodGlucoseProgress')}}</h2>
        <bg-line-graph style="margin-bottom: 24px;" :userId="$store.state.activeProfile"></bg-line-graph>
        <div style="clear:both"></div>
      </div>
      <div class="graphWrap">
        <h2>{{$t('message.labelWeightProgress')}}</h2>
        <weight-line-graph :userId="$store.state.activeProfile"></weight-line-graph>
        <div style="clear:both"></div>
      </div>
    </div>
    <p v-show="!showPrivacyProgress && !isAdmin">{{$t('message.labelGraphsPrivate')}}</p>
  </div>
</template>
<script>
  import BgLineGraph from "../../components/Tracking/Graphs/BloodGlucose/LineGraph";
  import WeightLineGraph from "../../components/Tracking/Graphs/Weight/LineGraph";
  import ProfileMixin from "../../mixins/ProfileMixin";
  export default {
    components: {
      WeightLineGraph,
      BgLineGraph
    },
    mixins: [
      ProfileMixin
    ],
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// ProfileProgress.vue?7a75857b